
export const properties={
    //url_api:'http://localhost:3000/items',
    url_api:'https://socdd.ducasse.cl/api/items',
    //url_api_base:"http://localhost:3000",
    url_api_base:"https://socdd.ducasse.cl/api",
}
